import { useContext } from 'react';
import { StaffInformation, Staff } from 'src/App';

export default function useStaffInformation(): Staff {
  return useContext(StaffInformation);
}
